const getByName = (elementInstance, name) => {
  if (elementInstance.$parent) {
    if (elementInstance.$parent.$options.name === name) {
      return elementInstance.$parent;
    }
    return getByName(elementInstance.$parent, name);
  }
  return null;
};

export default {
  getByName
};